import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SeekBackward15Icon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SeekBackward15",
    children: isCanvas ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "m23.19 4-.6-.32c-5-2.67-11.11-2.06-15.47 1.56L4.48 3.83c-.18-.1-.4-.08-.55.05-.16.12-.24.33-.19.53l1.68 6.29c.03.13.12.24.24.31s.27.08.41.04l6.17-2.09c.19-.06.33-.24.34-.44.02-.2-.08-.4-.26-.5L9.64 6.59l.55-.34c3.41-2.07 7.66-2.18 11.17-.28l.19.1c4.68 2.64 6.88 8.19 5.29 13.32-.14.43-.3.86-.49 1.28a11.18 11.18 0 0 1-6.71 6.05c-5.92 2.02-12.36-1.15-14.38-7.07-.34-.99-.54-2.02-.59-3.06a1.3 1.3 0 0 0-2.01-1.08c-.41.26-.65.71-.64 1.2.39 7.71 6.96 13.65 14.67 13.26 1.3-.07 2.58-.31 3.8-.73 3.7-1.22 6.71-3.94 8.29-7.5.15-.29.25-.61.36-.9 2.33-6.31-.17-13.39-5.95-16.83Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m12.71 11.94-2.16 1.12.33 1.29 1.19-.61v4.89h-1.33v1.36h4.15v-1.36h-1.36v-6.69zM19.32 18.57c-.23.13-.49.19-.77.19-.32 0-.6-.07-.87-.21-.26-.14-.57-.4-.9-.77l-.82.89c.3.45.67.79 1.12 1.03.44.25.95.36 1.49.36s1.04-.12 1.47-.37c.44-.25.78-.58 1.04-.99.26-.43.38-.9.38-1.42s-.11-.96-.34-1.36-.53-.71-.92-.94a2.5 2.5 0 0 0-1.31-.34c-.22 0-.44.02-.67.08-.2.05-.39.1-.56.18l.23-1.58h3.29v-1.3h-4.39l-.46 3.42.7.95c.27-.14.5-.25.68-.31.17-.07.33-.11.46-.14.14-.02.28-.03.43-.03.28 0 .53.07.75.19.22.13.4.3.52.52.13.22.2.46.2.74s-.07.5-.21.71q-.195.33-.54.51Z"
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M14.43 11.29c-.29 0-.58-.11-.81-.33L9.05 6.39a1.14 1.14 0 0 1 0-1.62L13.62.19a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-3.76 3.76 3.76 3.76a1.14 1.14 0 0 1-.81 1.95Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.57 31.86c-7.56 0-13.71-6.15-13.71-13.71 0-3.53 1.34-6.89 3.77-9.45a1.15 1.15 0 0 1 1.62-.04c.46.44.48 1.16.04 1.62a11.36 11.36 0 0 0-3.14 7.87c0 6.3 5.13 11.43 11.43 11.43s11.43-5.13 11.43-11.43S21.88 6.72 15.58 6.72H9.87a1.14 1.14 0 1 1 0-2.28h5.71c7.56 0 13.71 6.15 13.71 13.71s-6.15 13.71-13.71 13.71Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.34 16.97c-.32.4-.91.7-1.63.72v-2.12c1.1-.01 1.78-.61 1.91-1.5h2.03v9.06h-2.32v-6.16ZM15.21 22.54v-2.13h.04c.7.49 1.59.76 2.46.76.71 0 1.27-.4 1.27-1.07 0-.63-.49-1.07-1.38-1.07-.73 0-1.52.15-2.33.58h-.04l.53-5.52h5.02v2.12H17.7l-.13 1.15c.23-.05.44-.08.68-.08 1.67 0 3.08 1.19 3.08 2.86 0 1.84-1.5 3.13-3.59 3.13-1.01 0-2.06-.43-2.54-.73Z"
      })]
    })
  }));
};
SeekBackward15Icon.displayName = 'SeekBackward15Icon';